import { FormBasicsDto } from "@green0meter/api-client";
import React, { FC } from "react";

import { useRemoveForm } from "@api";
import { ConfirmationModal } from "@components/common";
import { useUserStore } from "@store/user";

interface RemoveFormDialog {
  form: FormBasicsDto;
  onClose: () => void;
}

const RemoveFormDialog: FC<RemoveFormDialog> = ({ form, onClose }) => {
  const { user } = useUserStore();
  const { removeForm, removeFormEnabled } = useRemoveForm(user);

  const handleRemove = (): void => {
    removeForm(form.id);
    onClose();
  };

  return (
    removeFormEnabled && (
      <ConfirmationModal
        title={`Remove form`}
        description={`Do you really want to remove '${form.name}'?`}
        open
        onClose={onClose}
        onConfirm={handleRemove}
      />
    )
  );
};

export default RemoveFormDialog;
